/* unplugin-vue-components disabled */import script from "./GoodExportModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./GoodExportModal.vue?vue&type=script&setup=true&lang=ts"

import "./GoodExportModal.vue?vue&type=style&index=0&id=d5d88b96&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5d88b96"]])

export default __exports__